const tableColumns =
     [
        {
            key: 'id',
            name: 'Inf.',
            num: 0
        },
        {
            key: 'place',
            name: 'Stad',
            num: 1
        },
        {
            key: 'gender',
            name: 'Kjønn',
            num: 2
        },
        {
            key: 'age',
            name: 'Alder',
            num: 3
        },
        {
            key: 'birth',
            name: 'Fødd i tidbolken',
            num: 4
        },
        {
            key: 'date_of_recording',
            name: 'Opptakstidspunkt',
            num: 5
        },
        {
            key: 'education',
            name: 'Utdanning',
            num: 6
        },
        {
            key: 'occupation',
            name: 'Yrke',
            num: 7
        },
        {
            key: 'parents_background',
            name: 'Foreldrebakgrunn',
            num: 8
        },
        {
            key: 'panel',
            name: 'Trend/Panel',
            num: 9
        }
    ];

export default tableColumns;